import {isEmpty} from 'lodash'
import constants from '@/libs/constant/constants'

export default{
    name: 'AddPublication',
    components: {
        SearchAuthor: () => import(/* webpackChunkName: "publication" */ '../../Author/SearchAuthor/SearchAuthor.vue'),
        ClaimedMessage: () => import(/* webpackChunkName: "publication" */ '../../../../component/ClaimedMessage/ClaimedMessage.vue'),
        ManageAuthor: () => import(/* webpackChunkName: "publication" */ '../../Author/ManageAuthor/ManageAuthor.vue'),
        ManageAuthorName: () => import(/* webpackChunkName: "publication" */ '../../Author/ManageAuthorName/ManageAuthorName.vue'),
        ManageAuthorDescription: () => import(/* webpackChunkName: "publication" */ '../../Author/ManageAuthorDescription/ManageAuthorDescription.vue'),
        ManageAuthorImage: () => import(/* webpackChunkName: "publication" */ '../../Author/ManageAuthorImage/ManageAuthorImage.vue'),
        AuthorConfirmation: () => import(/* webpackChunkName: "publication" */ '../../Author/AuthorConfirmation/AuthorConfirmation.vue'),
        MaintainAuthor: () => import(/* webpackChunkName: "group-card" */ '../../Author/MaintainAuthor/MaintainAuthor.vue'),
        AddArticle: () => import(/* webpackChunkName: "group-card" */ '../../Author/AddArticle/AddArticle.vue'),

    },
    beforeMount(){
        if(!isEmpty(this.$store.getters.getClaimTo)){
            this.claimTo = this.$store.getters.getClaimTo
        }
    },

    data(){
        return {
            termsAndPolicy: false,
            claimTo: {},
            active: 0,
            module: constants.PUBLICATION.key
        }
    },
    methods: {
        stepForward() {
            if (this.active++ > 5) this.active = 0;
        },
        stepBack(){
            if (this.active -- < 0) this.active = 0;
        },
        setClaimTo(claimTo){
            this.claimTo = claimTo
        },
        cancel (){
            this.$router.push('card')
        },
        getLogoCss(module){
            switch (module){
                case constants.AUTHOR.key:
                    return 'nova-authorprofile header'
                case constants.PUBLISHER.key:
                    return 'nova-publisher header'
                case constants.PUBLICATION.key:
                    return 'nova-publication header'
            }
        }
    }
}